import React, { Component } from "react";
import { Menu, Icon } from 'antd';
import { Link } from 'react-router-dom';
import equal from 'fast-deep-equal';

const { SubMenu } = Menu;

class HeaderApp extends Component {

  constructor(props) {
    super(props);
    this.state = { 
      notificationCounter: 0,
      loading: false,
      notifications: [] 
    };
  }

  componentDidUpdate(prevProps) {
    if(!equal(this.props.response, prevProps.response)) {
      this.updateNotifications(this.props.response);
    }
  }

  updateNotifications = (response) => {
    if (response && response.status && response.status === 500) {
      this.setState({
        notificationCounter: this.state.notificationCounter + 1,
        notifications: [...this.state.notifications, response.message]
      });
    }
  };

  handleMenuClick = e => {
    switch(e.key) {
      case 'clear':
        this.setState({
          notificationCounter: 0,
          notifications: []
        });
      break;
      case 'logout':
        this.showLogoutConfirm(this.props.onLogout);
      break;
      case 'settings':
      break;
      case 'profile':
      break;
      default:
        break;
    }
  }

  render() {
    return (
      <div>
        <Link to="/">
          <div className="logo">
            <label className="title">MAFUME</label>
            <label className="subtitle">S.R.L.</label>
          </div>
        </Link>
        <Menu align="right" mode="horizontal" theme="dark" onClick={this.handleMenuClick}>
          <SubMenu title={<span><Icon type="global"/></span>}>
            {/* <Menu.Item key="spanish">Spanish</Menu.Item>
            <Menu.Item key="english">English</Menu.Item> */}
          </SubMenu>
        </Menu>
      </div>
    )
  };
}

export default HeaderApp;



// WEBPACK FOOTER //
// ./src/components/header/header.js